import {useCallback} from 'react'

import Expandable from './Expandable'
import Primitive from './Primitive'

import type {LogValueNode, LogValueType} from '../../type'
import type {FC} from 'react'

const EXPANDABLE_TYPES: LogValueType[] = ['object', 'array', 'map', 'set']

interface LogValueInnerProps {
    node: LogValueNode
    depth: number
}

const LogValueInner: FC<LogValueInnerProps> = ({node, depth}) => {
    const renderValue = useCallback(
        (childNode: LogValueNode, childDepth: number) => <LogValueInner node={childNode} depth={childDepth} />,
        [],
    )

    if (EXPANDABLE_TYPES.includes(node.type)) {
        return <Expandable node={node} depth={depth} renderValue={renderValue} />
    }

    return <Primitive node={node} />
}

export default LogValueInner
